import { IRankingExtendedSearch } from "src/api/server/extended-search.types";

/**
 * Orders rankings to match the given key-figure order. Rankings whose id is not
 * part of `orderedFigureIds` (e.g. the relevance ranking) sort to the front and
 * keep their original relative order.
 */
export const orderRankingsByFigureIds = (
    rankings: ReadonlyArray<IRankingExtendedSearch>,
    orderedFigureIds: ReadonlyArray<string>
): ReadonlyArray<IRankingExtendedSearch> => {
    const figureIndexById = new Map(orderedFigureIds.map((id, index) => [id, index]));
    return [...rankings].sort((a, b) => (figureIndexById.get(a.id ?? "") ?? 0) - (figureIndexById.get(b.id ?? "") ?? 0));
};
